import { Routes } from "@angular/router";
import { LayoutComponent } from "./core/components/layout/layout.component";
import { DashboardComponent } from "./pages/dashboard/dashboard.component";
import { HomeComponent } from "./pages/home/home.component";
import { DronesComponent } from "./pages/drones/drones.component";
import { DroneFormComponent } from "./pages/drone-form/drone-form.component";
import { DroneDetailComponent } from "./pages/drone-detail/drone-detail.component";
import { LoginComponent } from "./pages/login/login.component";
import { Verify2faComponent } from "./pages/verify-2fa/verify-2fa.component";
import { Setup2faComponent } from "./pages/setup-2fa/setup-2fa.component";
import { SettingsComponent } from "./pages/settings/settings.component";
import { ProfileComponent } from "./pages/profile/profile.component";
import { ForgotPasswordComponent } from "./pages/forgot-password/forgot-password.component";
import { ResetPasswordComponent } from "./pages/reset-password/reset-password.component";
import { UsersComponent } from "./pages/users/users.component";
import { UserDetailComponent } from "./pages/user-detail/user-detail.component";
import { CreateUserComponent } from "./pages/create-user/create-user.component";
import { CreateUserOrganizationComponent } from "./pages/create-user-organization/create-user-organization.component";
import { OrganizationsComponent } from "./pages/organizations/organizations.component";
import { OrganizationDetailComponent } from "./pages/organization-detail/organization-detail.component";
import { OrganizationFormComponent } from "./pages/organization-form/organization-form.component";
import { OrganizationSetupWizardComponent } from "./pages/organization-setup-wizard/organization-setup-wizard.component";
import { EntitySuccessComponent } from "./pages/entity-success/entity-success.component";
import { DroneCatalogComponent } from "./pages/drone-catalog/drone-catalog.component";
import { ManufacturerDetailComponent } from "./pages/manufacturer-detail/manufacturer-detail.component";
import { ManufacturerFormComponent } from "./pages/manufacturer-form/manufacturer-form.component";
import { ModelFormComponent } from "./pages/model-form/model-form.component";
import { SafetyTestsComponent } from "./pages/safety-tests/safety-tests.component";
import { SafetyTestDetailComponent } from "./pages/safety-test-detail/safety-test-detail.component";
import { SafetyTestFormComponent } from "./pages/safety-test-form/safety-test-form.component";
import { FaaReportsComponent } from "./pages/faa-reports/faa-reports.component";
import { StateReportsComponent } from "./pages/state-reports/state-reports.component";
import { AcreageReportsComponent } from "./pages/acreage-reports/acreage-reports.component";
import { ChemicalReportsComponent } from "./pages/chemical-reports/chemical-reports.component";
import { ChemicalsListComponent } from "./pages/chemicals/chemicals-list/chemicals-list.component";
import { ChemicalFormComponent } from "./pages/chemicals/chemical-form/chemical-form.component";
import { EpaChemicalsListComponent } from "./pages/epa-chemicals/epa-chemicals-list/epa-chemicals-list.component";
import { EpaChemicalDetailComponent } from "./pages/epa-chemicals/epa-chemical-detail/epa-chemical-detail.component";
import { SponsorsListComponent } from "./pages/sponsors/sponsors-list/sponsors-list.component";
import { SponsorDetailComponent } from "./pages/sponsors/sponsor-detail/sponsor-detail.component";
import { UnassignedTicketsComponent } from "./pages/support/unassigned-tickets/unassigned-tickets.component";
import { FlightRecordsComponent } from "./pages/flight-records/flight-records.component";
import { DjiFlightsComponent } from "./pages/dji-flights/dji-flights.component";
import { DjiFlightDetailComponent } from "./pages/dji-flight-detail/dji-flight-detail.component";
import { FlightRecordDetailComponent } from "./pages/flight-record-detail/flight-record-detail.component";
import { ResetIntegrationComponent } from "./pages/reset-integration/reset-integration.component";
import { ResetHistoryComponent } from "./pages/reset-integration/history/reset-history.component";
import { AgremoCreditsComponent } from "./pages/agremo-credits/agremo-credits.component";
import { AgremoAnalysesComponent } from "./pages/agremo-analyses/agremo-analyses.component";
import { AgremoAnalysisDetailComponent } from "./pages/agremo-analysis-detail/agremo-analysis-detail.component";
import { MarketplacePaymentsLayoutComponent } from "./pages/marketplace-payments/marketplace-payments-layout.component";
import { PendingApprovalListComponent } from "./pages/marketplace-payments/pending-approval-list.component";
import { DisputesListComponent } from "./pages/marketplace-payments/disputes-list.component";
import { AllPaymentsListComponent } from "./pages/marketplace-payments/all-payments-list.component";
import { PayoutsPlaceholderComponent } from "./pages/marketplace-payments/payouts-placeholder.component";
import { PaymentDetailComponent } from "./pages/marketplace-payments/payment-detail.component";
import { DisputeDetailComponent } from "./pages/marketplace-payments/dispute-detail.component";
import { AuthGuard } from "./core/guards/auth.guard";
import { ClaimGuard } from "./core/guards/claim.guard";
import { SuperAdminGuard } from "./core/guards/super-admin.guard";
import { GlobalRoles } from './core/data-models/global-roles.model';
import { MatchType } from './core/data-models/match-type.model';
import { DroneReportsComponent } from "./pages/drone-reports/drone-reports.component";

export const routes: Routes = [
    // Public routes (no auth required)
    {
        path: 'login',
        component: LoginComponent
    },
    {
        path: 'verify-2fa',
        component: Verify2faComponent
    },
    {
        path: 'forgot-password',
        component: ForgotPasswordComponent
    },
    {
        path: 'reset-password',
        component: ResetPasswordComponent
    },
    // Protected routes (auth + admin role required)
    {
        path: '',
        component: LayoutComponent,
        canActivate: [AuthGuard, ClaimGuard],
        data: {
            claims: {
                roles: [GlobalRoles.Admin, GlobalRoles.SuperAdmin],
                matchType: MatchType.Any,
                redirectTo: '/login'
            }
        },
        children: [
            {
                path: '',
                redirectTo: 'dashboard',
                pathMatch: 'full'
            },
            {
                path: 'dashboard',
                component: DashboardComponent
            },
            {
                path: 'drones',
                component: DronesComponent
            },
            {
                path: 'drones/create',
                component: DroneFormComponent
            },
            {
                path: 'drones/:id/details',
                component: DroneDetailComponent
            },
            {
                path: 'drones/:id/edit',
                component: DroneFormComponent
            },
            {
                path: 'home',
                component: HomeComponent
            },
            {
                path: 'setup-2fa',
                component: Setup2faComponent
            },
            {
                path: 'settings',
                component: SettingsComponent
            },
            {
                path: 'account/profile',
                component: ProfileComponent
            },
            {
                path: 'users',
                component: UsersComponent
            },
            {
                path: 'users/create',
                component: CreateUserComponent
            },
            {
                path: 'users/create-organization',
                component: CreateUserOrganizationComponent
            },
            {
                path: 'users/:id',
                component: UserDetailComponent
            },
            {
                path: 'organizations',
                component: OrganizationsComponent
            },
            {
                path: 'organizations/create',
                component: OrganizationFormComponent
            },
            {
                path: 'organizations/:id',
                component: OrganizationDetailComponent
            },
            {
                path: 'organizations/:id/edit',
                component: OrganizationFormComponent
            },
            {
                path: 'organizations/:id/setup',
                component: OrganizationSetupWizardComponent
            },
            {
                path: 'success',
                component: EntitySuccessComponent
            },
            {
                path: 'drone-catalog',
                component: DroneCatalogComponent
            },
            {
                path: 'drone-catalog/create',
                component: ManufacturerFormComponent
            },
            {
                path: 'drone-catalog/:id',
                component: ManufacturerDetailComponent
            },
            {
                path: 'drone-catalog/:id/edit',
                component: ManufacturerFormComponent
            },
            {
                path: 'drone-catalog/:manufacturerId/models/create',
                component: ModelFormComponent
            },
            {
                path: 'drone-catalog/:manufacturerId/models/:modelId/edit',
                component: ModelFormComponent
            },
            // FAA Reports route
            {
                path: 'faa-reports',
                component: FaaReportsComponent
            },
            // State Reports route
            {
                path: 'state-reports',
                component: StateReportsComponent
            },
            // Acreage Reports route
            {
                path: 'acreage-reports',
                component: AcreageReportsComponent
            },
            // Chemical Reports route
            {
                path: 'chemical-reports',
                component: ChemicalReportsComponent
            },
            // Drone Reports route
            {
                path: 'drone-reports',
                component: DroneReportsComponent
            },
            // Safety Tests routes
            {
                path: 'safety-tests',
                component: SafetyTestsComponent
            },
            {
                path: 'safety-tests/create',
                component: SafetyTestFormComponent
            },
            {
                path: 'safety-tests/:id/details',
                component: SafetyTestDetailComponent
            },
            {
                path: 'safety-tests/:id/edit',
                component: SafetyTestFormComponent
            },
            // Chemicals routes (ADN Recommended)
            {
                path: 'chemicals',
                component: ChemicalsListComponent
            },
            {
                path: 'chemicals/create',
                component: ChemicalFormComponent
            },
            {
                path: 'chemicals/:id/edit',
                component: ChemicalFormComponent
            },
            // EPA Chemicals routes
            {
                path: 'epa-chemicals',
                component: EpaChemicalsListComponent
            },
            {
                path: 'epa-chemicals/:id',
                component: EpaChemicalDetailComponent
            },
            // Sponsors routes
            {
                path: 'sponsors',
                component: SponsorsListComponent
            },
            {
                path: 'sponsors/:id',
                component: SponsorDetailComponent
            },
            // Agremo routes
            {
                path: 'agremo-analyses',
                component: AgremoAnalysesComponent
            },
            {
                path: 'agremo-analyses/:id',
                component: AgremoAnalysisDetailComponent
            },
            {
                path: 'agremo-credits',
                component: AgremoCreditsComponent
            },
            // Flight Records routes
            {
                path: 'flight-records',
                component: FlightRecordsComponent
            },
            {
                path: 'flight-records/:id',
                component: FlightRecordDetailComponent
            },
            // DJI flight intake review (ADN-2451)
            {
                path: 'dji-flights',
                component: DjiFlightsComponent
            },
            {
                path: 'dji-flights/:id',
                component: DjiFlightDetailComponent
            },
            // Support routes
            {
                path: 'support/unassigned-tickets',
                component: UnassignedTicketsComponent
            },
            // Marketplace Payments — deferred-capture admin approval queue + dispute resolution.
            // Spec: agent-os/specs/2026-06-10-deferred-capture-admin-approval/spec.md (§ 5.3)
            {
                path: 'marketplace-payments',
                component: MarketplacePaymentsLayoutComponent,
                children: [
                    {
                        path: '',
                        redirectTo: 'pending-approval',
                        pathMatch: 'full'
                    },
                    {
                        path: 'pending-approval',
                        component: PendingApprovalListComponent
                    },
                    {
                        path: 'disputes',
                        component: DisputesListComponent
                    },
                    {
                        // All Payments tab — diagnostic / search view
                        // across every marketplace_payments row, any
                        // status. Distinct from Pending Approval
                        // (which is the actionable queue). Replaced
                        // the placeholder 2026-06-11.
                        path: 'all',
                        component: AllPaymentsListComponent
                    },
                    {
                        path: 'payouts',
                        component: PayoutsPlaceholderComponent
                    }
                ]
            },
            // Detail pages render outside the tab layout for full-bleed UX.
            {
                path: 'marketplace-payments/payment/:id',
                component: PaymentDetailComponent
            },
            {
                path: 'marketplace-payments/dispute/:id',
                component: DisputeDetailComponent
            },
            // System/Developer Tools routes (Super Admin only)
            {
                path: 'system/reset-integration',
                component: ResetIntegrationComponent,
                canActivate: [SuperAdminGuard]
            },
            {
                path: 'system/reset-integration/history',
                component: ResetHistoryComponent,
                canActivate: [SuperAdminGuard]
            }
        ]
    }
]
